import(/* webpackMode: "eager", webpackExports: ["Button"] */ "__barrel_optimize__?names=Button!=!/var/www/askpaul_web/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/askpaul_web/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/assets/common/title_logo.png");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/assets/search/tips_null@2x.png");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/common/Register/RegisterModal.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/category/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/header.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/header1.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/search/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/tabbar/index.tsx");
